<template>
  <div>
    <v-card>
      <v-list-item three-line class="pt-4 pr-3 pl-2" ref="cardRef">
        <v-list-item-content>
          <div class="text-h7 mb-1 pl-6">민들레 요가</div>
          <div class="text-h7 mb-1 pl-6">수업 예약하기</div>
          <div class="text-h7 pl-6">[ {{ reservatingDate }} ]</div>
        </v-list-item-content>
        <v-list-item-avatar
            tile
            size="80"
            class="mr-4"
        >
          <v-img :src="randomImage" max-height="100" contain/>
        </v-list-item-avatar>
      </v-list-item>
      <v-card-text class="pt-0 pr-3 pl-2" ref="cardTextRef">
        <v-card elevation="0" ref="cardFirstChild">
          <v-container
              id="input-usage"
              fluid
          >
            <v-row justify="center">
              <v-col cols="11" class="pt-0 pb-1">
                <v-text-field
                    label="이름"
                    color="black"
                    :value="this.$data.name"
                    @input="onNameInput"
                    :rules="this.rulesName"
                    class="info-input"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" class="mt-1">
              <v-col cols="11" class="pt-0 pb-1">
                <v-text-field
                    label="전화번호"
                    color="black"
                    :value="mobile"
                    @input="onMobileInput"
                    :rules="this.rulesMobile"
                    type="number"
                    pattern="\d*"
                    class="info-input"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" class="mt-2">
              <v-card-actions>
                <v-btn small @click="reserve" color="#F9CE0B" elevation="1" :disabled="this.reserveButtonDisabled">
                  🧘🏻‍♀ 예약하기 🧘🏻‍♂️
                </v-btn>
              </v-card-actions>
            </v-row>
          </v-container>
        </v-card>
        <v-card min-height="170" elevation="0" ref="cardSecondChild">
          <div v-if="event.details.attendees.length !==0">
            <v-list class="pr-2 pl-2 mt-1" ref="reservationList">
              <v-subheader ref="reservationListHeader">예약자 명단 ({{
                  event.details.attendees.length
                }}/{{ event.details.maxCount }})
              </v-subheader>
              <v-list-item>
                <v-list-item-content class="pt-0 pb-0" ref="reservationListBody">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th class="icon-fixed"/>
                        <th class="text-field">이름</th>
                        <th class="text-field">전화번호</th>
                        <th class="button-fixed"/>
                      </tr>
                      </thead>
                      <tbody>
                      <tr
                          v-for="(attendee, index) in event.details.attendees"
                          :key="index"
                      >
                        <td class="icon-fixed">
                          <v-avatar class="dots" color="black" :size="3"></v-avatar>
                        </td>
                        <td>
                          <span>{{ attendee.name }}</span>
                        </td>
                        <td>
                          <div class="mobileNumber">{{ attendee.mobile.substr(3, 1) }}XXX-XXXX</div>
                        </td>
                        <td class="button-fixed">
                          <v-btn
                              icon
                              small
                              class="mx-2"
                              color="none"
                              @click="()=>onClickDeleteBtn(attendee)"
                          >
                            <v-icon v-text="deleteIcon"></v-icon>
                          </v-btn>
                        </td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
          <div v-else>
            <v-list>
              <v-subheader>예약자 명단 ({{ event.details.attendees.length }}/{{ event.details.maxCount }})</v-subheader>
              <v-list-item>
                <v-list-item-content>
                  <span class="grey--text font-italic text-h8">예약자가 없습니다</span>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-card>

      </v-card-text>
    </v-card>

    <div v-if="this.deleteModalOpen">
      <v-dialog
          v-model="this.deleteModalOpen"
          width="500"
          @click:outside="() => {this.deleteModalOpen = false}"
          @keydown="onDeleteModalKeyDown"
      >
        <v-card>
          <v-card-title class="text-h5 ">
            예약취소
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col md="6">
                <v-otp-input v-model="otp" length="4" type="number" pattern="\d*"></v-otp-input>
              </v-col>
            </v-row>
            예약 취소를 위해 핸드폰 번호 끝 4자리를 입력하세요
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="red"
                dark
                @click="onSubmitCancelReservation"
            >
              예약 취소
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div v-if="this.dialogOpen">
      <v-dialog
          width="500"
          v-model="this.dialogOpen"
          @click:outside="() => {this.dialogOpen = false}"
          @keydown="onDialogKeyDown"
      >
        <alert
            :msg="this.dialogMsg"
            :sub-msg="this.dialogSubMsg"
            :ok-msg="this.okMsg"
            @clickDialogOk="clickDialogOk"
        />
      </v-dialog>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import axios from 'axios'
import _ from 'lodash'
import staticField from '../assets/static'
import Alert from "./Dialogs/Alert"
import Util from '../assets/util'

const numberPattern = /^[0-9]*$/
const mobilePattern = /^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/;

export default {
  name: 'form-sheet',
  components: {Alert},
  props: {
    event: {
      type: Object,
      required: true
    },
    onSucess: {
      type: Function,
      required: true
    }
  },
  mounted() {
    this.$parent.$el.getElementsByClassName("v-dialog--active")[0].addEventListener('transitionend', () => {

      // if (this.event.details.attendees.length !== 0) {
      //   const dialogHeight = this.$parent.$el.getElementsByClassName("v-dialog--active")[0].getBoundingClientRect().height;
      //   const titleHeight = this.$refs.cardRef.$el.clientHeight;
      //   const bodyHeight = this.$refs.cardTextRef.getBoundingClientRect().height;
      //   const cardFirstChild = this.$refs.cardFirstChild.$el.clientHeight;
      //   const cardSecondChild = this.$refs.cardSecondChild.$el.clientHeight;
      //   const reservationList = this.$refs.reservationList.$el;
      //   const reservationListHeader = this.$refs.reservationListHeader.$el;
      //
      //   const bodyPaddingBottom = this.getElementHeight(this.$refs.cardTextRef, false)
      //
      //
      //   const reservationListHeight = this.getElementHeight(reservationList, false)
      //   const reservationListSubHeaderHeight = this.getElementHeight(reservationListHeader)
      //
      //
      //   if (dialogHeight < titleHeight + bodyHeight) {
      //     console.log('Hello');
      //     console.log("다이얼로그 높이 : " + dialogHeight);
      //     console.log("타이틀 높이 : " + titleHeight);
      //     // console.log("바디 높이 : " + bodyHeight);
      //     console.log("첫번째 섹션 높이 : " + cardFirstChild);
      //     // console.log("두번째 섹션 높이 : " + cardSecondChild);
      //     console.log("예약자 명단 패딩 높이 : " + reservationListHeight);
      //     console.log("예약자 명단 헤더 높이 : " + reservationListSubHeaderHeight);
      //     console.log("섹션 높이 합 : " + (cardFirstChild + cardSecondChild));
      //     console.log('바디 패딩 바텀 높이 : ' + bodyPaddingBottom)
      //     // console.log("바디 타이틀 높이 합 : " + (titleHeight + bodyHeight));
      //     const expect = dialogHeight - titleHeight - cardFirstChild - reservationListHeight - reservationListSubHeaderHeight - bodyPaddingBottom;
      //     const reservationListBody = this.$refs.reservationListBody
      //     reservationListBody.style.height = expect + 'px';
      //     reservationListBody.style.overflow = 'auto';
      //
      //     console.log(reservationListBody.style.height);
      //     console.log(reservationListBody.style.overflow);
      //     console.log(reservationListBody)
      //     console.log('예상높이' + expect);
      //
      //   }
      // }
    });
  },
  data() {
    return ({
      model: this.event,
      name: '',
      mobile: '',
      deleteIcon: 'mdi-delete-outline',
      deleteModalOpen: false,
      otp: '',
      selectedAttendee: null,
      dialogOpen: false,
      dialogMsg: '',
      dialogSubMsg: '',
      rulesMobile: [
        value => !!value || '핸드폰 번호를 꼭 입력하셔야돼요',
        value => (value || '').length < 12 || '11자리만 입력해주세요!!',
        value => {
          return numberPattern.test(value) || '숫자만 입력해주세요!!'
        }
      ],
      rulesName: [
        value => !!value || '이름을 알려주세요..'
      ],
      reserveButtonDisabled: true,
      okMsg: ''
    });
  },
  computed: {
    reservatingDate() {
      const start = dayjs(this.model.start)
      const minute = start.format('mm')
      return start.format('MM/DD HH:') + (`${minute}`);
    },
    randomImage() {
      // return require('../assets/kokkam.jpg');

      const number = Math.floor(Math.random() * 100) + 1;

      if ((number%20) === 1) {
        return require('../assets/gucci.png');
      } else if ((number%20) === 2) {
        return require('../assets/kokkam.png');
      }
      return require('../assets/circlelogo.png');
    }
  },
  methods: {
    async reserve() {

      const {attendees, maxCount} = this.event.details;

      if (attendees.length >= maxCount) {
        this.dialogOpen = true;
        this.dialogMsg = '죄송해요 정원이 가득 찼습니다'
        this.okMsg = '어쩔 수 없죠😥'
        return;
      }

      const index = _.findIndex(attendees, (attendee) => attendee.name === this.name && attendee.mobile === this.mobile);
      if (index >= 0) {
        this.dialogOpen = true;
        this.dialogMsg = '이미 등록하셨는데요?'
        this.okMsg = '알겠습니다😅'
        return;
      }

      await this.$store.dispatch('setSelectedOpen', false);

      const eventCopy = Object.assign({}, this.event);

      eventCopy.details.attendees.push({name: this.name, mobile: this.mobile})

      const refreshData = {
        client_id: staticField.clientId,
        client_secret: staticField.clientSecret,
        grant_type: staticField.grantType,
        refresh_token: staticField.refreshToken,
      }


      const tokenData = await axios.post('https://oauth2.googleapis.com/token', refreshData)

      const body = {
        summary: `민들레 (${eventCopy.details.attendees.length}/${eventCopy.details.maxCount})`,
        description: JSON.stringify(eventCopy.details)
      }
      const config = {
        headers: {
          Authorization: `Bearer ${tokenData.data.access_token}`
        }
      }

      const {calendarID, googleKey} = staticField;
      try {
        await axios.patch(`${process.env.VUE_APP_GOOGLE_API}/calendar/v3/calendars/${calendarID}/events/${this.model.id}?key=${googleKey}`, body, config).then((_data, error) => {
          if (error) {
            this.$store.dispatch('setFailureMessage', '예약에 실패했습니다. 관리자에게 문의해주세요👾')
            this.$store.dispatch('setFailureSnackbarOpen', true);
            this.$store.dispatch('setSelectedOpen', false);

            setTimeout(() => {
              this.$store.dispatch('setFailureSnackbarOpen', false)
            }, 4000)
            return
          }
          this.$store.dispatch('setSuccessMessage', '🌼 예약 성공 🌼')
          this.$store.dispatch('setSuccessSnackbarOpen', true);
          setTimeout(() => {
            this.$store.dispatch('setSuccessSnackbarOpen', false)
          }, 4000)
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.onSucess();
      }
    },
    onNameInput(value) {
      this.name = value
      this.activateReserveButton()
    },
    onMobileInput(value) {
      this.mobile = value
      this.activateReserveButton()
    },
    onClickDeleteBtn(attendee) {
      const today = dayjs();

      if (dayjs(this.event.start).isSame(dayjs(), 'date')) {
        this.dialogMsg = "앱에서는 당일 취소가 불가합니다..!";
        this.dialogSubMsg = "수업 당일 예약 취소를 원하시면 민들레 요가로 연락주세요🙇‍♀️(횟수는 차감됩니다)"
        this.okMsg = "알겠어요🤦‍♀️";
        this.dialogOpen = true;
        return;
      }

      if (dayjs(this.event.start).isBefore(today, 'date')) {
        this.dialogMsg = "이미. 과거. 지난. 예약. 🤖";
        this.okMsg = "아하😕";
        this.dialogOpen = true;
        return;
      }
      this.deleteModalOpen = true;

      this.selectedAttendee = attendee

    },
    async onSubmitCancelReservation() {

      await this.$store.dispatch('setSelectedOpen', false);

      if (this.selectedAttendee.mobile.substr(this.selectedAttendee.mobile.length - 4, 4) === this.otp) {

        const eventCopy = Object.assign({}, this.event);
        eventCopy.details.attendees = eventCopy.details.attendees.filter((attendee) => {
          return !(attendee.name === this.selectedAttendee.name && attendee.mobile === this.selectedAttendee.mobile)
        })


        const refreshData = {
          client_id: staticField.clientId,
          client_secret: staticField.clientSecret,
          grant_type: staticField.grantType,
          refresh_token: staticField.refreshToken,
        }

        const tokenData = await axios.post('https://oauth2.googleapis.com/token', refreshData)

        const body = {
          summary: `민들레 (${eventCopy.details.attendees.length}/${eventCopy.details.maxCount})`,
          description: JSON.stringify(eventCopy.details)
        }
        const config = {
          headers: {
            Authorization: `Bearer ${tokenData.data.access_token}`
          }
        }

        const {calendarID, googleKey} = staticField;
        try {
          await axios.patch(`${process.env.VUE_APP_GOOGLE_API}/calendar/v3/calendars/${calendarID}/events/${this.model.id}?key=${googleKey}`, body, config).then((_data, error) => {
            if (error) {
              this.$store.dispatch('setFailureMessage', '예약취소에 실패했어요. 관리자에게 문의해주세요👾')
              this.$store.dispatch('setFailureSnackbarOpen', true);
              this.$store.dispatch('setSelectedOpen', false);

              setTimeout(() => {
                this.$store.dispatch('setFailureSnackbarOpen', false)
              }, 4000)
              return
            }

            this.$store.dispatch('setSuccessMessage', '예약을 취소했습니다👋')
            this.$store.dispatch('setSuccessSnackbarOpen', true);
            this.$emit('success')
            this.$emit('test');
            setTimeout(() => {
              this.$store.dispatch('setSuccessSnackbarOpen', false)
            }, 4000)
          })

        } catch (e) {
          console.log(e)

        } finally {
          this.onSucess();
        }

        this.deleteModalOpen = false;
      } else {
        await this.$store.dispatch('setFailureMessage', '잘못 입력하셨어요 👅')
        await this.$store.dispatch('setFailureSnackbarOpen', true);

        setTimeout(() => {
          this.$store.dispatch('setFailureSnackbarOpen', false)
        }, 4000)
      }

    },
    clickDialogOk() {
      this.dialogOpen = false;
    },
    activateReserveButton() {
      this.reserveButtonDisabled = !(numberPattern.test(this.mobile) && this.mobile && mobilePattern.test(this.mobile) && this.name && (this.mobile || '').length < 12);
    },
    onDeleteModalKeyDown(e) {
      Util.keyDownEventHandler(e, () => this.deleteModalOpen = false);
    },
    onDialogKeyDown(e) {
      Util.keyDownEventHandler(e, () => this.dialogOpen = false);
    },
    getElementHeight(node, includeBody = true) {
      const list = [
        'margin-top',
        'margin-bottom',
        'border-top',
        'border-bottom',
        'padding-top',
        'padding-bottom',
      ];

      includeBody && list.push('height');

      const style = window.getComputedStyle(node)
      return list
          .map(k => parseInt(style.getPropertyValue(k), 10))
          .reduce((prev, cur) => prev + cur)
    }
  }
}
</script>

<style scoped>
/*.v-avatar.dots {*/
/*  margin-right: 10px;*/
/*}*/

.v-btn:not(.v-btn--round).v-size--small {
  height: 35px;
}

.v-icon.notranslate.mdi.mdi-delete-outline.theme--light {
  font-size: 20px;
}

div.mobileNumber {
  display: flex;
  align-items: center !important;
}

.v-subheader {
  height: 36px;
}

.icon-fixed {
  width: 11px;
  padding: 0 0 0 10px !important;
}

.button-fixed {
  width: 28px;
  padding: 0 !important;
}

th {
  height: 35px !important;
}

td {
  /*height: 35px !important;*/
  /*font-size: 14px !important;*/
}

</style>
